import View from 'core/view';

export class PageRedirect extends View {
  static componentName = 'PageRedirect';
  static defaults = {
    backBtn: '.js-back-btn',
    continueBtn: '.js-continue-btn',
    headerClass: 'page-redirect-header',
    useHistoryClass: 'use-history'
  };

  init() {
    this.hasBrowserHistory = PageRedirect.checkBrowserHistory();
    this.backBtn = this.find(this.options.backBtn);
    this.continueBtn = this.find(this.options.continueBtn);
    this.updateView();
  }

  '{backBtn} on:click'(e) {
    this.onBackBtnClick(e);
  }

  '{window} on:breakpointchange'(breakpoint) {
    this.onBreakPointChange(breakpoint);
  }

  updateView() {
    $('.hpe-header, .hpe-footer').hide();
    $('.hpe-header').addClass(this.options.headerClass);

    if (this.hasBrowserHistory) {
      this.$el.addClass(this.options.useHistoryClass);
    }
    this.addClass('is-visible');
  }

  /**
   * handle clicks to the back button
   * if has browser history, stop the click and tell the browser to go back in history object
   * if no browser history, let click go to target href
   * @param {Object} e button event object
   */
  onBackBtnClick(e) {
    if (this.hasBrowserHistory) {
      e.preventDefault();
      // let currentPage = window.location.href;
      window.history.go(-1);
      // failsafe: if history is used but there is no page to go back to in history,
      // run a quick check and send browser to default location instead
      // setTimeout(function () {
      //   let defaultHref = $(e.target).attr('href');
      //   if (window.location.href === currentPage) {
      //     window.location.href = defaultHref;
      //   }
      // }, 500);
    }
  }

  /**
   * set order of the continue & back btns
   * if no browser history
   * for xs make back btn first
   * for s-xl make continue btn first
   * @param {String} breakpoint
   */
  onBreakPointChange(breakpoint) {
    if (!this.hasBrowserHistory) {
      if (breakpoint === 'xs' && this.isBackBtnFirst !== true) {
        this.continueBtn.insertBefore(this.backBtn);
        this.isBackBtnFirst = true;
      } else if (breakpoint !== 'xs' && this.isBackBtnFirst !== false) {
        this.backBtn.insertBefore(this.continueBtn);
        this.isBackBtnFirst = false;
      }
    }
  }

  static checkBrowserHistory() {
    if (window.history.length >= 2 && document.referrer !== '') {
      const referrerHost = document.referrer.split('/')[2];
      if (window.location.host === referrerHost) {
        return true;
      }
    }
    return false;
  }
}

export default PageRedirect;
